<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Category Store Group" subTitle="Forms" />

    <ListCategoryStoreGroup />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListCategoryStoreGroup from "@/components/Pages/Master/CategoryStoreGroup/ListCategoryStoreGroup.vue";

export default defineComponent({
  name: "ListCategoryStoreGroupPage",
  components: {
    PageTitle,
    ListCategoryStoreGroup,
  },
});
</script>
